import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from "../services/authentication.service";
import { NavigationService } from "@/core/services/navigation.service";

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  public constructor(
    private readonly _navigator: NavigationService,
    private readonly _authenticationService: AuthenticationService,
  ) {
  }

  public canActivate(): boolean {
    if (!this._authenticationService.currentAuthData) {
      return true;
    }
    this._navigator.navigateToLandingPage();
    return false;
  }
}
